// extracted by mini-css-extract-plugin
export default {"mobile_tabs":"SidebarNavigation_mobile_tabs__Hg1Lz","container":"SidebarNavigation_container__qTptf"};